import { all } from 'redux-saga/effects';
import { todoSaga } from './todo.saga';
import { walletSaga } from './wallet.saga';
import { loyaltyWalletSaga } from './loyalty-wallet.saga';

export default function* rootSaga() {
	yield all([todoSaga(), walletSaga(), loyaltyWalletSaga()]);
}
